module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_maedori@2x-eabb753872b9c440016200fdea5c469f.webp";